import { DataTable } from '@/components'
import { DataRow } from '@/pages/terms/agree/termsAgreeMgmt'
import { tableStyles } from '@/styles/dataTable/style'
import commonUtils from '@/utils/commonUtils'
import { useEffect } from 'react'
import { TableColumn } from 'react-data-table-component'
import styled from 'styled-components'

interface TermsAgreeHistMgmtProps {
  histData: DataRow[] // 부모에서 넘겨받은 histData
}
const TermsAgreeHistMgmt: React.FC<TermsAgreeHistMgmtProps> = ({
  histData,
}) => {
  const columns: TableColumn<DataRow>[] = [
    {
      name: 'No.',
      selector: (row) => row.rnum,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.rnum}</div>
      ),
    },
    {
      name: '회원번호',
      selector: (row) => row.cstId,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '약관ID',
      selector: (row) => row.termsId,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '동의버전',
      selector: (row) => row.agreeVer,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '순번',
      selector: (row) => row.seq,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '동의일자',
      selector: (row) => commonUtils.formatDate(row.agreeDate),
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '동의여부',
      selector: (row) => row.agreeYn,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '수정자',
      selector: (row) => row.updId,
      sortable: true,
      wrap: true,
    },
    {
      name: '수정일자',
      selector: (row) => commonUtils.formatDate(row.agreeYn),
      sortable: true,
      wrap: true,
    },
  ]

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '100px',
        }}
      >
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>약관동의이력</p>
      </div>
      <TableWrapper>
        <DataTable
          columns={columns}
          data={histData}
          customStyles={tableStyles}
          pagination={true}
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
        />
      </TableWrapper>
    </>
  )
}

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 400px;
`

export default TermsAgreeHistMgmt
